import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {GuidPickerDialogComponent, GuidPickerDialogData} from './guid-picker-dialog.component';
import {GuidInsertService} from '../../services/guid-insert/guid-insert.service';

@Component({
    selector: 'app-guid-picker-button',
    templateUrl: './guid-picker-button.component.html',
    styleUrls: ['./guid-picker-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GuidPickerButtonComponent {
  @Input() baseTable = '';
  @Input() fieldHint = '';

  constructor(
    private dialog: MatDialog,
    private guidInsertService: GuidInsertService,
  ) {}

  openPicker(): void {
    const selection = window.getSelection()?.toString() || this.guidInsertService.getLastSelection() || '';
    const fieldKey = this.extractFieldKey(selection) || this.fieldHint || '';

    this.dialog.open(GuidPickerDialogComponent, {
      width: '720px',
      data: {
        baseTable: this.baseTable,
        fieldKey,
      } as GuidPickerDialogData,
    });
  }

  private extractFieldKey(selection: string): string {
    const trimmed = (selection || '').trim();
    if (!trimmed) {
      return '';
    }

    const stripped = trimmed.replace(/^["'\s{\[]+|["'\s}\],:]+$/g, '');
    if (/^[A-Za-z_][A-Za-z0-9_]*$/.test(stripped)) {
      return stripped;
    }

    const match = stripped.match(/[A-Za-z_][A-Za-z0-9_]*Id$/);
    return match ? match[0] : '';
  }
}
